import { render, staticRenderFns } from "./successReceive.vue?vue&type=template&id=59e6c9a5&scoped=true"
import script from "./successReceive.vue?vue&type=script&lang=js"
export * from "./successReceive.vue?vue&type=script&lang=js"
import style0 from "./successReceive.vue?vue&type=style&index=0&id=59e6c9a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e6c9a5",
  null
  
)

export default component.exports